"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Card = _interopRequireDefault(require("./card/Card"));

var _Capability = _interopRequireDefault(require("./card/Capability"));

var _Session = _interopRequireDefault(require("./sip/Session"));

var _Item = _interopRequireDefault(require("./uc-item/Item"));

var _MessageItem = _interopRequireDefault(require("./uc-item/MessageItem"));

var _Capability2 = _interopRequireDefault(require("./user/Capability"));

var _User = _interopRequireDefault(require("./user/User"));

var _Capability3 = _interopRequireDefault(require("./video/Capability"));

var _Item2 = _interopRequireDefault(require("./video/Item"));

var _ScreenShareItem = _interopRequireDefault(require("./video/ScreenShareItem"));

var _VideoItem = _interopRequireDefault(require("./video/VideoItem"));

var _default = {
  card: {
    capabilityTypes: {
      DISMISSIBLE: 'DISMISSIBLE',
      SORTABLE: 'SORTABLE'
    },
    Capability: _Capability.default,
    Card: _Card.default
  },
  sip: {
    Session: _Session.default
  },
  ucInbox: {
    Item: _Item.default,
    MessageItem: _MessageItem.default
  },
  user: {
    capabilityTypes: {
      AUDIO: 'AUDIO',
      CHAT: 'CHAT',
      DATA: 'DATA',
      SCREEN: 'SCREEN',
      VIDEO: 'VIDEO'
    },
    Capability: _Capability2.default,
    User: _User.default
  },
  video: {
    capabilityTypes: {},
    Capability: _Capability3.default,
    Item: _Item2.default,
    ScreenShareItem: _ScreenShareItem.default,
    VideoItem: _VideoItem.default
  }
};
exports.default = _default;
module.exports = exports.default;